module.exports = __webpack_public_path__ + "static/media/bernard.92a9c85a.jpg";